import { VFC } from 'react'
import { useTheme } from '@opallabs/hooks'
import { Icon } from '@opallabs/lapidary'
import { useTextEditor } from '@opallabs/text-editor'
import * as styles from './styles'

type FullscreenToggleProps = {
  setFullScreen: (state: boolean) => void
}

export const FullscreenToggle: VFC<FullscreenToggleProps> = ({
  setFullScreen,
}) => {
  const { editor, saveContent } = useTextEditor()
  const theme = useTheme()

  const handleExit = () => {
    saveContent()
    setFullScreen(false)
    editor.commands.focus()
  }

  return (
    <button
      css={[styles.fullScreenClose, styles.fullScreenCloseDynamic({ theme })]}
      onClick={handleExit}
    >
      <span className="sr-only">Exit full screen</span>
      <Icon aria-hidden={true} glyph="gem-close" />
    </button>
  )
}
